import { render, staticRenderFns } from "./OneTimeCode.vue?vue&type=template&id=d00f275c&scoped=true"
import script from "./OneTimeCode.vue?vue&type=script&lang=js"
export * from "./OneTimeCode.vue?vue&type=script&lang=js"
import style0 from "./OneTimeCode.vue?vue&type=style&index=0&id=d00f275c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f275c",
  null
  
)

export default component.exports